import copyW4Json from '../../demo/fixtures/w4/copy.json'
import { Button, Card, Icon } from '../../ui'
import styles from './AutopilotSection.module.css'

interface CopyW4Fixture { inviteTitle4: string }

const copyW4 = copyW4Json as unknown as CopyW4Fixture

interface AutopilotInviteProps {
  copy: { title: string; body: string[]; cta: string }
  eligible: { ok: boolean; tip?: string }
  onOpen: () => void
}

export function AutopilotInvite({ copy, eligible, onOpen }: AutopilotInviteProps) {
  return (
    <Card className={styles.apCard} data-scope="ap-invite">
      <div className={styles.invite}>
        <span className={`${styles.inviteIcon} ${eligible.ok ? '' : styles.inviteIconOff}`}><Icon name="sparkle" size={22} strokeWidth={1.7} /></span>
        <div className={styles.inviteCopy}>
          <p className={styles.inviteTitle}>{copyW4.inviteTitle4}</p>
          <p className={styles.inviteBody}>{copy.body.map((line, index) => <span key={line}>{index ? <br /> : null}{line}</span>)}</p>
        </div>
        <span className={styles.inviteAction} title={eligible.ok ? undefined : eligible.tip}>
          <Button className={`${styles.runButton} ${styles.inviteButton}`} disabled={!eligible.ok} onClick={onOpen}>{copy.cta}</Button>
        </span>
      </div>
    </Card>
  )
}
